import Navbar from '@/components/Navbar'
import Hero from '@/components/Hero'
import FeaturedJobs from '@/components/FeaturedJobs'
import Footer from '@/components/Footer'

function Home() {
  return (
    <div className="bbq-home min-h-screen bg-white">
      <Navbar />
      <Hero />
      <FeaturedJobs />
      <Footer />
    </div>
  )
}

export default Home
